<!-- 旧路径兼容壳：正式入口 views/digital-card/index.vue -->
<script lang="ts">
export { default } from '@/views/digital-card/index.vue'
</script>
